<section class="faq-section">
  <umkt-loading 
    *ngIf="isLoading" 
    [isLoading]="isLoading" 
    [size]="'md'" 
    [showText]="true" 
    [text]="'components.faqSection.loading' | i18n" 
    mode="contained">
  </umkt-loading>

  <ng-container *ngIf="!isLoading">
    <div class="faq-title-container">
      <h3 class="faq-title">{{ title }}</h3>
      <p class="faq-description">{{ description }}</p>
    </div>

  <!-- Desktop version -->
    <div class="faq-menu-container desktop-only">
      <h4 class="faq-menu-title">{{ getSelectedFaqItem()?.text }}</h4>
      <div class="faq-content">
        <umkt-list-item 
          [items]="faqItems" 
          [selectedItemId]="selectedFaqItem" 
          [showDividers]="true"
          [textColor]="'var(--color-neutral-950-to-white)'" 
          [padding]="'16px'" 
          [fontSize]="'16px'" 
          [fontWeight]="'400'"
          (itemSelected)="onFaqItemSelected($event)" 
          [style.width]="'35%'">
        </umkt-list-item>
        <umkt-collapse-panel 
          [panels]="getSelectedFaqItem()?.questions || []"
          [leftIconClass]="'mdn-Icon-faq mdn-Icon--md'" 
          [style.width]="'65%'">
        </umkt-collapse-panel>
      </div>
    </div>

  <!-- Mobile version -->
    <div class="faq-mobile-container mobile-only">
      <select class="faq-mobile-select" [value]="selectedFaqItem" (change)="onFaqSelectChange($event)">
        <option value="" disabled>{{ 'components.faqSection.selectTopic' | i18n }}</option>
        <option *ngFor="let item of faqItems" [value]="item.id">
          {{ item.text }}
        </option>
      </select>
      
      <div class="faq-mobile-card" *ngIf="selectedFaqItem && selectedFaqItem !== ''">
        <div class="faq-mobile-header">
          <h4 class="faq-mobile-title">{{ getSelectedFaqItem()?.text }}</h4>
        </div>
        <div class="faq-mobile-content"
          *ngIf="getSelectedFaqItem()?.questions && getSelectedFaqItem()?.questions!.length > 0">
          <umkt-collapse-panel 
            [panels]="getSelectedFaqItem()?.questions || []"
            [leftIconClass]="'mdn-Icon-faq mdn-Icon--md'">
          </umkt-collapse-panel>
        </div>
        <div class="faq-mobile-content" *ngIf="!getSelectedFaqItem()?.questions?.length">
          <p class="faq-no-questions">{{ 'components.faqSection.noQuestions' | i18n }}</p>
        </div>
      </div>
      
      <div class="faq-mobile-card" *ngIf="!selectedFaqItem || selectedFaqItem === ''">
        <div class="faq-mobile-header">
          <h4 class="faq-mobile-title">{{ 'components.faqSection.selectTopic' | i18n }}</h4>
        </div>
        <div class="faq-mobile-content">
          <p class="faq-select-prompt">{{ 'components.faqSection.selectPrompt' | i18n }}</p>
        </div>
      </div>
    </div>
  </ng-container>
</section>